var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/cchgdprcompliance/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal", "services/navigator", "services/settings"], function (require, exports, Common, Portal, Navigator, Configuration) {
    "use strict";
    var CchGDPRComplianceViewModel = (function (_super) {
        __extends(CchGDPRComplianceViewModel, _super);
        function CchGDPRComplianceViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.cdnEndPoint = Configuration.Settings.environment.getCustomValue("CdnEndPoint");
            this.productImage = this.cdnEndPoint + "content/images/logo.png";
            this.productTitle = "CCH GDPR Compliance";
            this.testimonials = [];
            this.toolkits = [];
            this.informationToSendToClient = [];
            this.initializeTestimonials();
            this.initializeToolkits();
            this.initializeInformationToSendToClient();
            this.title = "CchGDPRCompliance";
            ko.track(this, ["tabSelected", "testimonials"]);
        }
        CchGDPRComplianceViewModel.prototype.onActivated = function (context) {
            this.tabSelected = 0;
            this.shopId = context.queryString.shopId;
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            this.createCchGDPRComplianceCrumb();
            this.spliceLastBreadcrumbs(context, calledFromTools);
            this.getCchGDPRComplianceDetails();
            this.createCchGDPRComplianceDetailsCrumb();
        };
        CchGDPRComplianceViewModel.prototype.initializeTestimonials = function () {
            var testimonial1 = {
                image: this.cdnEndPoint + "content/images/French_Duncan_logo.png",
                text: '"Organisations that are well prepared for GDPR have a distinct competitive advantage over those that are not.  If clients ask us about GDPR, we want to be able to show that we understand the issues involved and that we’re taking all reasonable steps to comply."<br /><br />"GDPR introduces a new principle of accountability - it\'s not enough to just comply with the regulations, you have to be able to demonstrate compliance and prove the governance measures you’ve put in place.The GDPR compliance software makes this much easier to do, which is just one of the ways in which it helps us."',
                name: "<br />Andrew Guy, IT Director, French Duncan",
                link: "",
                customCss: "cch-gdpr-product-testimonial-logo-image-large"
            };
            this.testimonials.push(testimonial1);
        };
        CchGDPRComplianceViewModel.prototype.initializeToolkits = function () {
            var toolkit1 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/FAQ-CCH-GDPR-Compliance.pdf",
                text: 'FAQ - CCH GDPR Compliance',
                icon: "fa-file-text-o"
            };
            var toolkit2 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/Product-information-CCH-GDPR-Compliance.pdf",
                text: 'Product information - CCH GDPR Compliance',
                icon: "fa-file-text-o"
            };
            this.toolkits.push(toolkit1);
            this.toolkits.push(toolkit2);
        };
        CchGDPRComplianceViewModel.prototype.initializeInformationToSendToClient = function () {
            var informationToSendToClient1 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/GDPR-Guide-for-SMEs.docx",
                text: "GDPR Guide for SMEs (sales)",
                icon: "fa-file-text-o"
            };
            var informationToSendToClient2 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/GDPR-Guide-for-SMEs-Referral.docx",
                text: "GDPR Guide for SMEs (referrals)",
                icon: "fa-file-text-o"
            };
            this.informationToSendToClient.push(informationToSendToClient1);
            this.informationToSendToClient.push(informationToSendToClient2);
        };
        CchGDPRComplianceViewModel.prototype.createCchGDPRComplianceCrumb = function () {
            // initial add of CchGDPRCompliance breadcrumb
            if (this.breadCrumb.items.length === 0) {
                this.addCchGDPRComplianceCrumbToBreadcrumbItems();
            }
        };
        CchGDPRComplianceViewModel.prototype.spliceLastBreadcrumbs = function (context, calledFromTools) {
            // calledFromTools - flag to see where CchGDPRCompliance is called from (null - called from Dashboard, not null - called from Tools)
            if (this.breadCrumb.items.length > 1) {
                // for the CchGDPRCompliance page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 2, 2);
                }
            }
            else {
                // for the CchGDPRCompliance page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                    this.addCchGDPRComplianceCrumbToBreadcrumbItems();
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
            }
        };
        CchGDPRComplianceViewModel.prototype.addCchGDPRComplianceCrumbToBreadcrumbItems = function () {
            var crumb = Portal.BreadCrumbItem.from("i-Serve");
            crumb.clickAction = function () { Navigator.navigateTo("iServe", "index", "/iServe", null); };
            this.breadCrumb.items.push(crumb);
        };
        CchGDPRComplianceViewModel.prototype.getCchGDPRComplianceDetails = function () {
            this.node = Portal.Context.shell.findNodeByUID(this.shopId);
        };
        CchGDPRComplianceViewModel.prototype.createCchGDPRComplianceDetailsCrumb = function () {
            var crumb = Portal.BreadCrumbItem.from(this.node.name);
            this.breadCrumb.items.push(crumb);
        };
        CchGDPRComplianceViewModel.prototype.selectTab = function (index) {
            this.tabSelected = index;
        };
        return CchGDPRComplianceViewModel;
    }(Common.ViewModelBase));
    var instance = new CchGDPRComplianceViewModel();
    return instance;
});

